/** The List stages action element. */
import { MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { ActivityEntityName } from '../../shared/activity.entity.name';
import { WorkflowActionType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowSideEffect } from '../workflow.element';

/** Lists the run's Job's stages, so a For each can go over `steps.<id>.items`. */
export const LIST_JOB_STAGES_ELEMENT: WorkflowElement = {
    type: WorkflowActionType.ListJobStages,
    family: WorkflowFamily.Stage,
    sideEffect: WorkflowSideEffect.Read,
    title: 'List the Job\'s stages',
    icon: 'fa-list-check',
    fields: [],
    outputs: [
        { path: 'items', itemTitle: 'This stage', metadata: { displayName: 'Stages', type: MetadataEntityFieldType.Lookup, arrayOf: MetadataEntityFieldType.Lookup, entity: ActivityEntityName.WorkOrder } },
        { path: 'items.id', metadata: { displayName: 'Stage ID', type: MetadataEntityFieldType.Lookup, entity: ActivityEntityName.WorkOrder } },
        { path: 'items.name', metadata: { displayName: 'Stage name', type: MetadataEntityFieldType.String } },
        { path: 'items.stageNumber', metadata: { displayName: 'Stage number', type: MetadataEntityFieldType.String } },
        // The tenant status as a record, typed from the stage's own Status field, so a condition picks from the tenant's stage statuses.
        { path: 'items.status', entityField: { entity: ActivityEntityName.WorkOrder, field: 'status' }, metadata: { displayName: 'Status', type: MetadataEntityFieldType.Lookup, entity: ActivityEntityName.WorkOrderStatus } },
        { path: 'items.statusName', metadata: { displayName: 'Status name', type: MetadataEntityFieldType.String } },
        // The system status the tenant status rolls up to (`SystemWorkOrderStatus`, as a Job's status holds it), typed from the stage status's own field.
        { path: 'items.systemStatus', entityField: { entity: ActivityEntityName.WorkOrderStatus, field: 'systemStatus' }, metadata: { displayName: 'System status', type: MetadataEntityFieldType.Enum } },
    ],
};
